<template>
  <div class="party_container">
    <MySwiper :picData="pictureData.political.top_banner" :swiperOption="swiperOption"/>

    <div class="tabs_container">
      <div class="tabs_container_wrap">
        <div class="tabs_nav">
          <ul>
            <li
              class="tabs_nav_item"
              v-for="(party, index) in politicalPartyData"
              :key="index"
              :class="currentIndex == index ? 'tabs_nav_choose' : ''"
              @click="goTab(party.id,index,party.type,party.name )"
            >
              {{ party.name }}
              <img
                v-if="currentIndex == index"
                class="tabs_nav_item_img"
                src="../../assets/image/tab1.png"
                alt=""
              />
            </li>
          </ul>
        </div>
        <div class="tabs_detail">
          <div class="tabs_detail_title">{{currentName}}</div>
          <!-- <div class="keyword">搜索 <span>爱心</span> 获得约 <span>115</span> 条结果</div> -->
          <ul v-if="currentType == 'article'">
            <li class="tabs_detail_content_item" v-for="(article, index) in navArticleInfo.data"
              :key="index" 
              @click="goDetailArticle(article.id)"
              >
              <div class="tabs_detail_content_item_left">
                <img
                  class="tabs_detail_content_item_left_img"
                  :src="article.image"
                  alt=""
                />
              </div>
              <div class="tabs_detail_content_item_right">
                <div class="tabs_detail_content_item_right_tit">
                  {{article.title}}
                </div>
                <div class="tabs_detail_content_item_right_time">
                  <img class="icon" src="../../assets/image/date.png" alt="" />
                  <span>{{article.article_date}}</span>
                </div>
                <div class="tabs_detail_content_item_right_content">
                  <span class="txt">{{article.subtitle | ellipsis}}</span>
                  <span>[</span>
                  <span class="detail">详情</span>
                  <span>]</span>
                </div>
              </div>
            </li>
          </ul>
          <div class="tabs_detail_text" v-else v-html="partyContent"></div>
          <Pagination
            :total="navArticleInfo.total"
            :pageSize="pageSize"
            :pageNow="currentPage"
            :continues="10"
            :sendPageNow="getPageNow"
            v-if="currentType == 'article' && navArticleInfo.data && navArticleInfo.data.length"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MySwiper from '@/components/common/swiper.vue';
import Pagination from "@/components/common/pagination.vue";
export default {
  name: "PartyConstruction",
  data() {
    return {
      currentIndex: 0,
      currentId:1,
      currentType:'content',
      currentName:'',
      partyContent:'',
      currentPage: 1,
      pageSize:10,
      swiperOption: {
        loop: true, // 是否循环播放
        speed: 400, // 切换速度 ms
        // allowTouchMove: false, // 是否允许鼠标滑动
        // touchRatio: 0.5,
        // touchAngle: 10, // 是否允许手指滑动
        // effect: 'fade', // 切换方式
        centeredSlides: true,

        pagination: {
        el: ".swiper-pagination",
        clickable: true
        },
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
        }
        // preventLinksPropagation: false, // 阻止点击事件冒泡
        // preloadImages: false // 是否强制加载所有图片
      },
    };
  },
  filters: {
    ellipsis(v) {
      let txt = "";
      if (v && v.length > 100) {
        txt = v.slice(0, 100) + "...";
      }else{
        txt = v
      }
      return txt;
    },
  },
  methods: {
    goTab(id,index,type,name) {
      this.currentId = id;
      this.currentIndex = index;
      this.currentType = type;
      this.currentName = name;
      this.currentPage = 1;
      if(type == 'article'){
        this.$store.dispatch('getNavArticleData',{id:id,currentPage:this.currentPage,pageSize:this.pageSize})
      }else if(type == 'content'){
        const currentParty = this.politicalPartyData.find(item => item.id == id);
          this.partyContent = currentParty.content;
      }else{
          this.partyContent = '';
      }
    },
    // 获取点击后的页码
    getPageNow(n) {
      //更新参数
      this.currentPage = n;
      //发请求
      this.$store.dispatch('getNavArticleData',{id:this.currentId,currentPage:n,pageSize:this.pageSize})
    },
    goDetailArticle(id){
      this.$router.push({
          name: 'detail',
          query: {
            id:id,
            type: 'article',
            scene: 4,
            nav_id: this.currentId,
            keyword:'',
          } 
      });
    },
  },

  components: { Pagination,MySwiper },
  computed: {
    ...mapState({
      politicalPartyData: (state) => state.politicalParty.politicalPartyData,
      pictureData: (state) => state.material.pictureData,
      navArticleInfo: state=>state.material.navArticleInfo,
    }),
  },
  mounted() {
    this.$store.dispatch("getPoliticalPartyData");
    this.$store.dispatch("getPicture");
  },
  watch:{
    "$store.state.politicalParty.politicalPartyData":{
      deep:true,
      handler(newPartyData){
        this.currentType = newPartyData[0].type;
        this.currentId = newPartyData[0].id;
        this.currentName = newPartyData[0].name;
        if(newPartyData[0].type == 'article'){
          this.$store.dispatch('getNavArticleData',{id:this.currentId,currentPage:this.currentPage,pageSize:this.pageSize})
        }else if(newPartyData[0].type == 'content'){
          const currentParty = newPartyData[0]
          this.partyContent = currentParty.content;
        }else{
          this.partyContent = '';
        }
      },
    }
  }
};
</script>

<style scoped lang="stylus">
.party_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .swiper {
    width: 100%;
    height: 560px;

    .swiper-wrapper {
      .slide-img {
        width: 100%;
        height: 100%;
      }
    }

    .my_pagination {
      :deep(.swiper-pagination-bullet:focus ) {
        outline: none;
      }

      :deep(.swiper-pagination-bullet-active ) {
        opacity: 1;
        background-clip: content-box;
        background: rgba(255, 255, 255, 0.5);
      }

      :deep(.swiper-pagination-bullet-active:before ) {
        content: '';
        position: absolute;
        height: 4px;
        left: 0;
        top: 0;
        width: 0;
        opacity: 1;
        background: #ffffff;
        border-radius: 2px;
        background-clip: content-box;
        -webkit-animation: bannerProgress 7.3s ease-in-out;
        -moz-animation: bannerProgress 7.3s ease-in-out;
        -o-animation: bannerProgress 7.3s ease-in-out;
        -ms-animation: bannerProgress 7.3s ease-in-out;
        animation: bannerProgress 7.3s ease-in-out;
        z-index: 186;
        overflow: hidden;
      }

      :deep(.swiper-pagination-bullet ) {
        position: relative;
        margin: 20px 10px;
        border-radius: 2px;
        background: rgba(255, 255, 255, 0.5);
        opacity: 1;
        width: 50px;
        height: 4px;
        background-clip: content-box;
        z-index: 168;
        top: -3px;
      }
    }
  }
  @keyframes bannerProgress {
    100% {
      width: 50px;
    }
  }

  .tabs_container display flex, flex-direction column, align-items center, .tabs_container_wrap {
    width: 1180px;
    display: flex;
    margin: 60px 0;

    .tabs_nav {
      width: 230px;
      height: 100%;

      ul {
        .tabs_nav_item {
          position: relative;
          width: 100%;
          height: 50px;
          font-size: 16px;
          font-family: SourceHanSansCN-Normal SourceHanSansCN;
          line-height: 50px;
          text-align: center;
          color: #666;

          .tabs_nav_item_img {
            width: 10px;
            height: 12px;
            position: absolute;
            top: 18px;
            right: 18px;
          }
        }

        .tabs_nav_choose {
          background: #014EA2;
          color: #fff;
        }
      }
    }

    .tabs_detail {
      width: 100%;
      padding-left: 70px;
      box-sizing: border-box;
      border-left: 1px solid #F5F5F5;

      .tabs_detail_title {
        width: 100%;
        height: 50px;
        border-bottom: 1px solid #F5F5F5;
        font-size: 36px;
        font-family: SourceHanSansCN-Normal SourceHanSansCN;
        font-weight: 500;
        color: #000000;
        line-height: 35px;
        margin-bottom: 40px;
      }

      .keyword {
        font-size: 16px;
        color: #666;
        margin-bottom: 30px;

        span {
          color: red;
        }
      }
      .tabs_detail_text{
        padding-bottom: 60px;
        :deep(img){
            max-width: 100%;
        }
        :deep(ol){
            margin-left: 30px;
        }
        :deep(ul){
            margin-left: 30px;
        }
      }

      ul {
        padding-bottom: 60px;

        .tabs_detail_content_item {
          width: 100%;
          display: flex;
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #000000;
          padding: 10px 0;
          cursor: auto;

          .tabs_detail_content_item_left {
            width: 280px;
            height: 210px;
            margin-right: 20px;
            overflow: hidden;

            .tabs_detail_content_item_left_img {
              width: 280px;
              height: 210px;
              transition: all 0.5s;
            }
          }

          .tabs_detail_content_item_left:hover .tabs_detail_content_item_left_img {
            transform: scale(1.1);
          }

          .tabs_detail_content_item_right {
            width: 580px;
            height: 100%;

            .tabs_detail_content_item_right_tit {
              font-size: 20px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #000000;
              cursor: pointer;
              &:hover{
                color: #014EA2;
              }
            }

            .tabs_detail_content_item_right_time {
              margin: 20px 0;
              height: 20px;

              .icon {
                width: 20px;
                height: 16px;
                margin-right: 6px;
                vertical-align: middle;
              }

              span {
                display: inline-block;
                font-size: 14px;
                height: 20px;
                line-height: 20px;
                font-family: AlibabaPuHuiTiR;
                color: #666666;
              }
            }

            .tabs_detail_content_item_right_content {
              font-size: 14px;
              font-family: SourceHanSansCN-Normal, SourceHanSansCN;
              font-weight: 400;
              color: #333;
              padding-bottom: 40px;
              cursor: pointer;
              &:hover{
                color: #014EA2;
              }
               .txt{
                // overflow hidden
                // text-overflow: ellipsis;
                // display: -webkit-box;
                // -webkit-line-clamp: 2;
                // -webkit-box-orient: vertical;
               }

              .detail {
                color: #014EA2;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>